import React, { useState, Fragment } from "react";
import "./_home.scss";
// import whiteLogo from "../../Assets/Images/Zencelogo.svg";
import zservice from "../../Assets/Images/zservice1.png";
import EaseofUse from "../../Assets/Images/EaseofUse.png";
import ProductSpecificReviews from "../../Assets/Images/ProductSpecificReviews.png";
import AutomatedReviewCollection from "../../Assets/Images/AutomatedReviewCollection.png";
import CustomizableReviewDisplay from "../../Assets/Images/CustomizableReviewDisplay.png";
import ReviewManagementMonitoring from "../../Assets/Images/ReviewManagementMonitoring.png";
import DetailedReviewAnalytics from "../../Assets/Images/DetailedReviewAnalytics.png";
import SeamlessWebsiteIntegration from "../../Assets/Images/SeamlessWebsiteIntegration.png";
// import clientLogo from "../../Assets/Images/clientLogo.png";
// import starRating from "../../Assets/Images/starRating.png";
import BookDemo from "../Login/BookDemo";
import LoginForm from "../Login/LoginForm";

export default function IndependenceDayOfferpage() {
  const [activeTab, setActiveTab] = useState(0);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleTabActive = (tabNo) => {
    setActiveTab(tabNo);
  };

  return (
    <Fragment>
      <section className="hero-section offer-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
            <h2 className="heroNew-main-heading roboto-regular"><img src={zservice}  alt="Zence Logo" /></h2>
             
              {/* <h1 className="hero-heading roboto-bold">
                #RightToExclusiveOffer{" "}
              </h1> */}
              <h2 className="hero-sub-heading roboto-regular">
                Boost your Brand's Reputation{" "}
              </h2>
              <h2 className="hero-sub-heading roboto-regular">
                <b>Collect Authentic Reviews and Ratings</b> <br className="hidden-xs hidden-md" /> from
                 verified buyers to
                enhance your brand’s credibility
              </h2>
              {/* <h3 className="hero-free-trial-para roboto-bold">
                <span>Start 1 Month Free Trial</span>
              </h3> */}

              <div className="mt-5 text-center visible-xs">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                 Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-4 px-0 hidden-xs">
              <div className="login-container">
                <div className="input-form">
                  <h4 className="login-form-heading text-center roboto-bold">
                  INTERESTED? <br />
                    TALK TO AN EXPERT
                  </h4>
                  <LoginForm />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container-fluid">
        <div className="d-flex justify-content-end">
            <p className="t-and-c-text roboto-regular">*T&C Apply </p>
            </div>
        </div> */}
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row mb-5">
            <div className="col-lg-12 m-auto">
              <h4 className="page-heading roboto-bold text-center">
              Convert potential buyers into customers with a robust <br className="hidden-xs hidden-md"/>Review Management Solution
              </h4>
              <p className="page-content-para roboto-regular text-center">
              Influence buyers’ purchasing decisions with positive reviews and boost conversions
              </p>
            </div>
          </div>
          <div className="row align-items-center gap-3 column-reverse">
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img src={EaseofUse} className="main-image" alt="" />
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              <h4 className="text-heading roboto-bold mb-3">Ease of Use</h4>
              <p className="text-para roboto-regular">
                Capture and display customer feedback without any technical
                hassle. With an intuitive interface, you can quickly set up your
                review system and start gathering valuable insights from your
                customers
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3">
            <div className="col-lg-5  m-auto">
              <h4 className="text-heading roboto-bold mb-3">
                Product-Specific Reviews
              </h4>
              <p className="text-para roboto-regular">
                Collect detailed reviews based on specific SKUs, allowing you to
                gather targeted feedback for individual products. This helps you
                understand the performance of each product and address any
                specific issues or improvements needed
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img
                  src={ProductSpecificReviews}
                  className="main-image"
                  alt=""
                />
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3 column-reverse">
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img
                  src={AutomatedReviewCollection}
                  className="main-image"
                  alt=""
                />
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              <h4 className="text-heading roboto-bold mb-3">
                Automated Review Collection
              </h4>
              <p className="text-para roboto-regular">
                Save time and effort with our automated review collection
                feature. Automatically send review requests to customers after a
                purchase, ensuring you receive timely and relevant feedback
                without manual intervention
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content claim-free-trial-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-9 m-auto">
              <p className="text-para roboto-regular">
                Increase Online Reputation and Sales <br />
                Collect authentic reviews to build trust and credibility
              </p>
            </div>
            <div className="col-lg-3">
              <button
                className="btn btn-schedule-demo roboto-medium"
                onClick={() => handleShow()}>
               Get a Demo
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3">
            <div className="col-lg-5  m-auto">
              <h4 className="text-heading roboto-bold mb-3">
                Customizable Review Display
              </h4>
              <p className="text-para roboto-regular">
                Tailor the appearance of your review pages to seamlessly
                integrate with your website’s design and brand identity.
                Customize fonts, colors, and layouts to create a cohesive look
                that aligns with your brand
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img
                  src={CustomizableReviewDisplay}
                  className="main-image"
                  alt=""
                />
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3 column-reverse">
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img
                  src={ReviewManagementMonitoring}
                  className="main-image"
                  alt=""
                />
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              <h4 className="text-heading roboto-bold mb-3">
                Review Management and Monitoring
              </h4>
              <p className="text-para roboto-regular">
                Stay in control of the reviews displayed on your site with our
                comprehensive monitoring system. Use the dashboard to approve,
                reject, or respond to reviews, ensuring only the most relevant
                and positive feedback is showcased
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3">
            <div className="col-lg-5  m-auto">
              <h4 className="text-heading roboto-bold mb-3">
                Detailed Review Analytics
              </h4>
              <p className="text-para roboto-regular">
                Access in-depth analytics and insights on review data through
                our user-friendly dashboard. Track metrics such as review
                volume, average ratings, and sentiment analysis to make informed
                decisions based on customer feedback
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img
                  src={DetailedReviewAnalytics}
                  className="main-image"
                  alt=""
                />
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3 column-reverse">
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img
                  src={SeamlessWebsiteIntegration}
                  className="main-image"
                  alt=""
                />
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              <h4 className="text-heading roboto-bold mb-3">
                Seamless Website Integration
              </h4>
              <p className="text-para roboto-regular">
                Integrate our review system effortlessly with your website using
                iframe injection. This ensures a smooth and efficient setup
                process without the need for extensive technical knowledge or
                resource
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content faq-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hr-line-container mb-5">
                <div className="hr-line left-s-line"></div>
                <div className="col-6 px-0">
                  <h4 className="page-heading roboto-bold text-center">
                    <span>Frequently Asked Questions (FAQ)</span>
                  </h4>
                </div>
                <div className="hr-line right-s-line"></div>
              </div>
            </div>
            <div className="col-lg-10 m-auto">
              <div className="accordion accordion-flush" id="accordionFlushExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button
                      className="accordion-button roboto-bold collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne">
                      Do we need to have a Zence CRM solution to enable reviews?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                    data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                      <p className="text-para roboto-regular">
                        No, the reviews module can be enabled with any CRM
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button
                      className="accordion-button roboto-bold collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo">
                      Is the ‘Write Review’ Page customizable?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                      <p className="text-para roboto-regular">
                        Yes, the entire look of the page can be customized to
                        match your requirements
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingThree">
                    <button
                      className="accordion-button roboto-bold collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree">
                      Is the ‘Show Review’ Page customizable?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree"
                    data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                      <p className="text-para roboto-regular">
                        The show review page is fully customizable to match your
                        requirements and website UI
                      </p>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingFour">
                    <button
                      className="accordion-button roboto-bold collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour">
                      I have more than one brand for which I want to integrate
                      reviews, is it possible?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingFour"
                    data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                      <p className="text-para roboto-regular">
                        Yes, we can configure multiple brands under the same
                        umbrella to have individual reviews linked for each
                        brand
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingFive">
                    <button
                      className="accordion-button roboto-bold collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFive"
                      aria-expanded="false"
                      aria-controls="flush-collapseFive">
                      I do not have a tech team to support website integration
                      for the show review page, is the integration simple?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingFive"
                    data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                      <p className="text-para roboto-regular">
                        Yes, integration with the website is straightforward and
                        does not require extensive development from a tech team
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingSix">
                    <button
                      className="accordion-button roboto-bold collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSix"
                      aria-expanded="false"
                      aria-controls="flush-collapseSix">
                      I want to be able to see the stats on the review page, can
                      I view them on a dashboard?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseSix"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingSix"
                    data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                      <p className="text-para roboto-regular">
                        Yes, you can view and download reports on reviews
                        received for analysis
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="page-content claim-free-trial-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-9 m-auto">
              <p className="text-para roboto-regular">
                <b>Struggling to get authentic reviews?</b>
              </p>
              <p className="text-para roboto-regular mt-2">
                Try Zence Review & Rating solution and understand your
                 customers better
              </p>
            </div>
            <div className="col-lg-3">
              <button
                className="btn btn-schedule-demo roboto-medium"
                onClick={() => handleShow()}>
                Get a Demo
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="page-content industries-section mt-0 pb-2">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-12 m-auto">
              <h4 className="text-normal-heading roboto-bold mb-3 mt-0">
                Terms and Conditions{" "}
              </h4>
              <ul className="section-ul ps-3">
                <li>
                  Final subscription charges depend on applicable offer basis
                  product suite and duration
                </li>
                <li>Zence reserves the right to withdraw the offer anytime </li>
              </ul>
            </div> */}
          </div>
        </div>
      </section>

      <BookDemo showModal={show} handleCloseModal={handleClose} />
    </Fragment>
  );
}
